module.exports = {"type":"FeatureCollection","crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"}},"features":[{"type":"Feature","properties":{"created_at":"2014-03-09T19:11:53Z","cartodb_id":126,"name":"Droga5","updated_at":"2014-03-09T19:11:53Z"},"geometry":{"type":"Polygon","coordinates":[[[-74.00673836537905,40.704915340609006],[-74.00604585263412,40.704456448245196],[-74.00546683523795,40.70482815560314],[-74.00620317717369,40.70528527975429]]]}}]}


//////////////////
// WEBPACK FOOTER
// ./src/droga.json
// module id = 81
// module chunks = 0